export default class PayCode {
  constructor(title, code, isTest=true, use=false) {
      this.title = title;
      this.code = code;
      this.use = use;
      this.isTest = isTest;
  }
}